import React, {useEffect, useState} from 'react'
import {Checkbox, Col, Row, Collapse } from "antd";
import {assignPermission, unAssignPermission} from "../../services/serviceRolePermission";

const {Panel} = Collapse

const RolePermissionItems = ({permissionList, roleId, headers}) => {

    const [checkedList, setCheckedList] = useState([])
    const [options, setOptions] = useState([])

    useEffect(() => {
        let optionArray = []
        permissionList.map(item => {
            let pushObj = {
                label: item.description,
                value: item.id
            }
            optionArray.push(pushObj)
        })
        setOptions(optionArray)
    }, [])

    useEffect(() => {
        let checkedList = []
        permissionList.map(item => {
            if (item.hasPermission !== '0')
                checkedList.push(item.id)
        })
        setCheckedList(checkedList)
    }, [])

    const handleChange = ({target}) => {
        let checked = target.checked
        let permissionId = target.value
        if (checked) {
            assignPermission({permissionId: permissionId, roleId: roleId})
                .then(data => data)
        } else {
            unAssignPermission({permissionId: permissionId, roleId: roleId})
                .then(data => data)
        }
    }


    return (
        <React.Fragment>
            <Collapse
                defaultActiveKey={['1']}
            >

                <Panel header={headers}>
                    <Row>
                        <Checkbox.Group defaultValue={checkedList}>

                            {options.map(item => {

                                return (
                                    <Col key={item.value} span={24}>
                                        <Checkbox value={item.value} key={item.value}
                                                  onChange={handleChange}>{item.label}</Checkbox>
                                    </Col>
                                )
                            })}
                        </Checkbox.Group>
                    </Row>
                </Panel>
            </Collapse>

        </React.Fragment>
    )
}
export default RolePermissionItems
